import DOMPurify from "dompurify";

/** Sanitize untrusted HTML (site rules, email bodies) before dangerouslySetInnerHTML. */
export const safeHtml = (html) => ({
  __html: DOMPurify.sanitize(html || "", { USE_PROFILES: { html: true }, FORBID_TAGS: ["style", "form", "input"] }),
});
